
import React from "react";
import { PremiumBenefits } from "./premium/PremiumBenefits";

const BenefitsSection = () => {
  return <PremiumBenefits />;
};

export default BenefitsSection;
